import { AuthCredentials } from '@/types';

const STORAGE_KEY = 'atlassian_credentials';

const AUTH_STATUS_KEY = 'auth_status';

export const AuthService = {
  saveCredentials(credentials: AuthCredentials, rememberMe: boolean): void {
    if (rememberMe) {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(credentials));
      localStorage.setItem(AUTH_STATUS_KEY, 'true');
    } else {
      localStorage.removeItem(STORAGE_KEY);
      localStorage.removeItem(AUTH_STATUS_KEY);
    }
  },

  loadCredentials(): AuthCredentials | null {
    try {
      const savedCredentials = localStorage.getItem(STORAGE_KEY);
      return savedCredentials ? JSON.parse(savedCredentials) : null;
    } catch (error) {
      console.error('Failed to parse saved credentials:', error);
      return null;
    }
  },

  clearCredentials(): void {
    // Don't remove credentials, just set auth status to false
    localStorage.setItem(AUTH_STATUS_KEY, 'false');
  }
};